const delay = (ms) => new Promise((r) => setTimeout(r, ms));

function hasQueryRules(query) {
  if (!query?.rules?.length) return false;
  return query.rules.some((r) => ("rules" in r ? hasQueryRules(r) : Boolean(r.field)));
}

export const REPORT_DATASETS = [
  {
    id: "vehicles",
    name: "Vehicle events",
    description: "High-frequency CAN and GPS telemetry per asset",
    rows: 12_000_000,
    scanSize: "2.1 TB",
    fields: ["speed", "fuel", "odometer", "city", "driver_id", "vehicle_id", "timestamp", "ignition", "temperature", "rpm"],
  },
  {
    id: "drivers",
    name: "Driver data",
    description: "Driver profiles, assignments, and compliance scores",
    rows: 50_000,
    scanSize: "156 GB",
    fields: ["driver_id", "name", "license", "score", "fleet_id", "status", "hire_date", "city"],
  },
  {
    id: "trips",
    name: "Trip summary",
    description: "Pre-aggregated trip legs with distance and idle time",
    rows: 8_000_000,
    scanSize: "1.2 TB",
    fields: ["trip_id", "vehicle_id", "driver_id", "start_time", "end_time", "distance_km", "fuel_used", "idle_minutes", "city"],
  },
];

const SAVED_REPORTS = [];

export async function listReportDatasets() {
  await delay(80);
  return REPORT_DATASETS.map(({ fields, ...ds }) => ({ ...ds, fieldCount: fields.length }));
}

export async function getReportDataset(datasetId) {
  await delay(40);
  return REPORT_DATASETS.find((d) => d.id === datasetId) ?? null;
}

export async function estimateReport(config) {
  await delay(120);
  const dataset = REPORT_DATASETS.find((d) => d.id === config.datasetId) ?? REPORT_DATASETS[0];
  const filterFactor = Math.max(0.15, 1 - config.filters.length * 0.12);
  const groupFactor = config.groupBy.length > 0 ? 0.72 : 1;
  const metricFactor = 1 + config.metrics.filter((m) => m.field).length * 0.08;
  const sessionFactor =
    hasQueryRules(config.session?.startQuery) || hasQueryRules(config.session?.endQuery) ? 0.85 : 1;

  const estimatedRows = Math.round(dataset.rows * filterFactor * sessionFactor);
  const scanGb = parseFloat(dataset.scanSize) * filterFactor * groupFactor;
  const runtimeSec = Math.max(2, Math.round((scanGb / 0.25) * metricFactor));

  return {
    rows: estimatedRows,
    scan: `${scanGb.toFixed(1)} ${dataset.scanSize.includes("TB") ? "TB" : "GB"}`,
    runtimeSec,
    costUnits: Math.round(scanGb * 4.2),
  };
}

export async function saveReport({ name, config }) {
  await delay(200);
  const entry = {
    id: `rpt-${Date.now().toString(36)}`,
    name: name.trim(),
    config,
    createdAt: new Date().toISOString(),
  };
  SAVED_REPORTS.unshift(entry);
  return entry;
}

export async function listSavedReports() {
  await delay(60);
  return [...SAVED_REPORTS];
}
